import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AuthProvider, Login, ProtectedRoute } from './auth';
import { ErrorBoundary, Layout } from './components';
import { queryClient } from './lib/query-client';
import { RomaneioEntregadores } from './features/romaneio/RomaneioEntregadores';
import { RomaneioEntregadoresEntrego } from './features/romaneio/RomaneioEntregadoresEntrego';
import { RomaneioCadastroEntrego } from './features/romaneio/pages/romaneio-cadastro-entrego';
import { RomaneioAntecipacao } from './features/romaneio/pages/romaneio-antecipacao';
import { EntregoFechamento } from './features/romaneio/pages/entrego-fechamento';
import { MuveFechamento } from './features/romaneio/pages/muve-fechamento';
import { IndriveFechamento } from './features/romaneio/pages/indrive-fechamento';
import { IndrivePagamento } from './features/romaneio/pages/indrive-pagamento';
import { RomaneioCheckout } from './features/romaneio/RomaneioCheckout';
import { RomaneioPayment } from './features/romaneio/RomaneioPayment';
import { RomaneioStatistics } from './features/romaneio/pages/romaneio-statistics';
import { UploadPage } from './features/upload';
import { Home } from './pages/Home';
import { Unauthorized } from './pages/Unauthorized';
import { store } from './store';

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Home />} />

                        {/* Romaneio Routes */}
                        <Route
                          path="/romaneio/entregadores"
                          element={<RomaneioEntregadores />}
                        />
                        {/* Legacy route redirects */}
                        <Route
                          path="/romaneio/cadastro"
                          element={<RomaneioEntregadores />}
                        />
                        <Route
                          path="/romaneio/entregador"
                          element={<RomaneioEntregadores />}
                        />
                        <Route
                          path="/romaneio/entregadores-entrego"
                          element={<RomaneioEntregadoresEntrego />}
                        />
                        <Route
                          path="/romaneio/checkout"
                          element={<RomaneioCheckout />}
                        />
                        <Route
                          path="/romaneio/statistics"
                          element={<RomaneioStatistics />}
                        />
                        <Route
                          path="/romaneio/payment"
                          element={<RomaneioPayment />}
                        />
                        <Route
                          path="/romaneio/antecipacao"
                          element={<RomaneioAntecipacao />}
                        />
                        <Route
                          path="/romaneio/cadastro-entrego"
                          element={<RomaneioCadastroEntrego />}
                        />

                        {/* Entrego Fechamento */}
                        <Route
                          path="/romaneio/entrego-fechamento"
                          element={<EntregoFechamento />}
                        />

                        {/* Muve Fechamento */}
                        <Route
                          path="/romaneio/muve-fechamento"
                          element={<MuveFechamento />}
                        />

                        {/* Indrive Fechamento */}
                        <Route
                          path="/romaneio/indrive-fechamento"
                          element={<IndriveFechamento />}
                        />

                        {/* Indrive Pagamento */}
                        <Route
                          path="/romaneio/indrive-pagamento"
                          element={<IndrivePagamento />}
                        />

                        {/* Upload Route */}
                        <Route path="/upload" element={<UploadPage />} />

                        {/* Shared Routes */}
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AuthProvider>
          </Router>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
